// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (min-width: 1250px) {
  .fuse-confirmation-dialog-panel{
    width: 32rem;
  }
}
.fuse-confirmation-dialog-panel .mat-dialog-container {
  padding: 0 !important;
}

#c-divider {
  margin: 15px 0px 5px 0px !important;
}

#c-success-alert {
  margin-top: 15px !important;
}

pdf-viewer {
  display: block;
}

.fa-file-download {
  margin-right: 5px;
}

.mat-dialog-content {
  background: white !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.c-dialog-content {
  padding: 0px !important;
  overflow: hidden !important;
  height: 60vh;
}

#viewerContainer {
  top: 30px !important;
}

#c-close {
  position: relative;
  top: -5px;
}

iframe {
  width: 100%;
  height: 60vh;
  /* 60% af skjáhæð */
  border: none;
}

.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.pdf-placeholder {
  text-align: center;
}

.pdf-container {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/dialog-pdf/dialog-pdf.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE;IAAA;EAAA;AAGJ;AAAE;EACE,qBAAA;AAEJ;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,4BAAA;EAIA,8DAAA;AAHF;;AAMA;EACE,uBAAA;EACA,2BAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".fuse-confirmation-dialog-panel {\r\n  @screen md {\r\n    @apply w-128;\r\n  }\r\n\r\n  .mat-dialog-container {\r\n    padding: 0 !important;\r\n  }\r\n}\r\n\r\n#c-divider {\r\n  margin: 15px 0px 5px 0px !important;\r\n}\r\n\r\n#c-success-alert {\r\n  margin-top: 15px !important;\r\n}\r\n\r\npdf-viewer {\r\n  display: block;\r\n}\r\n\r\n.fa-file-download {\r\n  margin-right: 5px;\r\n}\r\n\r\n.mat-dialog-content {\r\n  background: white !important;\r\n}\r\n\r\n.mat-dialog-content {\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\r\n}\r\n\r\n.c-dialog-content {\r\n  padding: 0px !important;\r\n  overflow: hidden !important;\r\n  height: 60vh;\r\n}\r\n\r\n#viewerContainer {\r\n  top: 30px !important;\r\n}\r\n\r\n#c-close {\r\n  position: relative;\r\n  top: -5px;\r\n}\r\n\r\niframe {\r\n  width: 100%;\r\n  height: 60vh;\r\n  /* 60% af skjáhæð */\r\n  border: none;\r\n}\r\n\r\n.pdf-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.pdf-placeholder {\r\n  text-align: center;\r\n}\r\n\r\n.pdf-container {\r\n  height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
